import { render } from "./InputDemo.vue?vue&type=template&id=445cf16c&scoped=true"
import script from "./InputDemo.vue?vue&type=script&lang=js"
export * from "./InputDemo.vue?vue&type=script&lang=js"

import "./InputDemo.vue?vue&type=style&index=0&id=445cf16c&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-445cf16c"]])

export default __exports__